import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlimScrollModule } from 'ng2-slimscroll';
import { BroadcastComponent } from './broadcast/broadcast.component';
import { AlertComponent } from './alert/alert.component';
import { SharedModule } from './../../shared/shared.module';
import { ViewGroupsComponent } from './../view-groups/view-groups.component';
import { ViewMembersComponent } from './../view-members/view-members.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    SlimScrollModule
  ],
  exports : [
    ViewGroupsComponent, 
    ViewMembersComponent
  ],
  declarations: [BroadcastComponent, AlertComponent, ViewGroupsComponent, ViewMembersComponent]
})
export class ComposeMessageModule { }



// WEBPACK FOOTER //
// ./src/app/feed/compose-message/compose-message.module.ts